import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useLocalePath, useT } from "../i18n";
import { LEGAL_NAV, MAIN_NAV } from "../config/navigation";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const MobileMenu = ({ open }) => {
  const t = useT();
  const lp = useLocalePath();
  const reduce = useReducedMotion();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const item = (i) => ({
    initial: reduce ? false : { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.12 + i * 0.06 },
  });

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="mobile-menu"
          className="fixed inset-0 z-40 flex flex-col bg-ink text-white xl:hidden"
          initial={reduce ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
        >
          <nav className="container-x flex flex-1 flex-col justify-center overflow-y-auto pb-4 pt-24" aria-label="Mobile">
            <p className="micro-label mb-6 text-white/40">{t("ui.menu")}</p>
            <ul className="border-t border-white/10">
              {MAIN_NAV.map((key, i) => (
                <motion.li key={key} {...item(i)} className="border-b border-white/10">
                  <Link to={lp(key)} data-testid={`mobile-nav-${key}`} className="group flex min-h-[64px] items-center gap-5 py-3 sm:min-h-[76px]">
                    <span className="micro-label w-7 shrink-0 tabular-nums text-white/35">0{i + 1}</span>
                    <span className="mobile-nav-label font-display text-[2rem] leading-none transition-transform duration-500 group-hover:translate-x-2 sm:text-5xl">
                      {t(`nav.${key}`)}
                    </span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </nav>
          <motion.div
            {...item(MAIN_NAV.length)}
            className="container-x flex flex-col gap-1 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-6 sm:flex-row sm:items-center sm:justify-between sm:pb-8"
          >
            <LanguageSwitcher id="mobile" className="text-sm" />
            <div className="flex gap-7 text-xs text-white/45">
              {LEGAL_NAV.map((key) => (
                <Link key={key} to={lp(key)} data-testid={`mobile-legal-${key}`} className="inline-flex min-h-[44px] items-center transition-colors duration-300 hover:text-white">
                  {t(`nav.${key}`)}
                </Link>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
